import React, { useState } from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import Header from '../../components/headers/Header'
import HeaderHome from '../../components/headerHome/HeaderHome';
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { FormularioRegistroEstandar } from '../../components/Registro/FormularioRegistroEstandar';
import './SingUp.css';
import { useNavigate } from 'react-router-dom';

export const SingUp = (props) => {
  /* A hook that is used to change the state of the menu. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  const navigate = useNavigate();

  const opciones = [
    {
      tipo: 'cliente',
      titulo: 'Soy cliente',
      descripcion: 'Accede a tu perfil, gestiona tus citas y conecta con profesionales de forma sencilla.',
      linkTo: '/registro/cliente',
    },
    {
      tipo: 'profesional',
      titulo: 'Soy profesional',
      descripcion: 'Crea tu perfil, recibe reservas y mejora la visibilidad de tu consulta o clínica.',
      linkTo: '/registro/profesional',
    },
  ];

  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }

  return (
    <>
      <div className='Registro' onClick={closeMenu}>
        <div className='headerRegistro'>
          <HeaderHome />
        </div>
        <div className="bodyRegistro">
          <div className='container mt-5 mb-5'>
            <h2 className="text-center mb-4 fw-bold">Elige el tipo de cuenta</h2>
            <div className="row justify-content-center gap-3">
              {opciones.map((opcion) => (
                <div
                  key={opcion.tipo}
                  className="col-md-5"
                  onClick={() => navigate(opcion.linkTo)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="card shadow-sm p-4 text-center h-100 border-0 hover-shadow transition">
                    <div className="mb-3">
                    </div>
                    <h5 className="fw-semibold">{opcion.titulo}</h5>
                    <p className="text-muted">{opcion.descripcion}</p>
                  </div>
                </div>
              ))}
              </div>
            </div>
          </div>
        <div className='footerRegistro'>
          <MiFooter />
        </div>
      </div>
    </>
  )
}